var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('header-view'),(!_vm.pageLoading)?_c('div',{staticClass:"wrapper-content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('router-view')],1)])])]):_c('clip-loader',{staticClass:"loading",attrs:{"color":"gray","size":"30px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }